export const version = 'kunde-cc4913d674d8109a76da8af032071f77ad151282';